import React from 'react';

export default function Left(props) {
  return (
    <svg viewBox="0 0 40 40" {...props}>
      <path d="M25.7 12.34L18.05 20l7.65 7.66L23.36 30l-10-10 10-10z" />
    </svg>
  );
}



// WEBPACK FOOTER //
// ./app/components/icons/left.js